export default __webpack_public_path__ + "static/media/howToPayments.23da130e.png";